import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerPaymentInformationRoutingModule } from './customer-payment-information-routing.module';
import { CustomerPaymentInformationComponent } from './customer-payment-information.component';
import { MatButtonModule } from '@angular/material/button';
import { CustomerDisplayPaymentMethodModule } from '../customer-display-payment-method/customer-display-payment-method.module';
import { LoadingModule } from '../../shared/loading/loading.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CustomerPaymentInformationComponent],
  imports: [
    CommonModule,
    CustomerPaymentInformationRoutingModule,
    MatButtonModule,
    CustomerDisplayPaymentMethodModule,
    LoadingModule,
    FormsModule,
  ],
  exports: [CustomerPaymentInformationComponent],
})
export class CustomerPaymentInformationModule {}
